import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useWarmUpSession } from "@/hooks/useWarmUpSession";

// Argument-less mutation covering all the user's dealers; run once per browser
// session, keyed by user so a different sign-in on the same tab still warms up.
const warmUpFiredKey = (userId: string) =>
  `dxp.deviceSync.warmUpFired:${userId}`;

export const DeviceSyncWarmUp = () => {
  const { user } = useAuth();
  const userId = user?.profile.sub;
  const [warmUpSession] = useWarmUpSession();

  useEffect(() => {
    if (!userId) {
      return;
    }
    const key = warmUpFiredKey(userId);
    if (sessionStorage.getItem(key)) {
      return;
    }
    sessionStorage.setItem(key, "1");

    warmUpSession().catch(() => {
      sessionStorage.removeItem(key);
    });
  }, [userId, warmUpSession]);

  return null;
};
